import { useIsPermitted } from "@/hooks/useIsPermitted";
import { ROLES } from "@/common/permissions";
import { ReactNode } from "react";
import { toast } from "@/utils/toast.utils";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/contexts/AuthContext";

interface RoleProtectedRouteProps {
  children: ReactNode;
  role: ROLES;
}

export function RoleProtectedRoute({
  children,
  role,
}: RoleProtectedRouteProps) {
  const { t } = useTranslation();
  const isPermitted = useIsPermitted(role);
  const { signOut } = useAuth();

  if (!isPermitted) {
    toast.error(t("errors.unauthorizedPage"));

    signOut();
    return null;
  }

  return <>{children}</>;
} 